import * as React from 'react';
import { Image } from 'telia-front-react';
export const Telia1Image = (props) => {
    const { imageWidth } = props;
    return (React.createElement(Image, { srcset: "//res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_127/icons/Telia1_1.svg 127w, //res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_254/icons/Telia1_1.svg 254w\\", width: imageWidth, role: "presentation", align: "left" }));
};
